import { TableField } from "../../table-field";

const dsTipoAnexo: TableField = {
    key: "DsTipoAnexo",
    label: "Descrição",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const tpGrupoAnexo: TableField = {
    key: "TpGrupoAnexo",
    label: "Grupo",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const flObrigatorio: TableField = {
    key: "FlObrigatorio",
    label: "Obrigatório",
    tdClass: ["align-middle", "text-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const flPermiteMultiplos: TableField = {
    key: "FlPermiteMultiplos",
    label: "Múltiplos",
    tdClass: ["align-middle", "text-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const nrOrdem: TableField = {
    key: "NrOrdem",
    label: "Ordem",
    tdClass: ["align-middle", "text-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const vigencia: TableField = {
    key: "vigencia",
    label: "Vigência",
    tdClass: ["align-middle", "text-center", "naoQuebrar"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const actions: TableField = {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};

export const fieldsTiposAnexo: TableField[] = [
    dsTipoAnexo,
    tpGrupoAnexo,
    flObrigatorio,
    flPermiteMultiplos,
    nrOrdem,
    vigencia,
    actions,
];
